import { Component, OnInit } from '@angular/core';
import { MdbModalModule, MdbModalRef } from "mdb5-adapted";
import { FormsModule } from '@angular/forms';
import { LmsModalFrameComponent } from '@lmsSharedUI';

@Component({
    selector: 'app-remove-loan-type',
    templateUrl: './remove-loan-type.component.html',
    styleUrls: ['./remove-loan-type.component.scss'],
    standalone: true,
    imports: [FormsModule, MdbModalModule, LmsModalFrameComponent]
})
export class RemoveLoanTypeDialogComponent implements OnInit {
  pageName = "Delete Product";
  loanTypeData: any;
  submitted = false;

  constructor(
    public dialogRef: MdbModalRef<RemoveLoanTypeDialogComponent>) { }

  ngOnInit(): void {
  }

  removeLoanTypeConfirmation() {
    this.submitted = true;
    let isValidData = true;

    if (this.loanTypeData.id == null) {
      isValidData = false;
      console.log("Form fields are null or empty...");
    }

    if (isValidData) {
      return this.dialogRef.close(this.loanTypeData);
    }
  }

  close() {
    this.dialogRef.close();
  }

}
